import { useContext } from 'react';
import ChannelContext from '@jetshop/core/components/ChannelContext';

//SHARED LOGIC FOR SWITCHING BETWEEN THE PRIVATE (B2C) AND COMPANY (B2B) CHANNELS
export const useB2BChannel = () => {
  const { channels, selectedChannel, updateChannel } =
    useContext(ChannelContext);

  const isB2B = !!selectedChannel.name.includes('B2B');

  const getChannels = ({ channelsRaw, getB2B }) => {
    const isDev =
      typeof window !== 'undefined' &&
      (window.location.host.search('dev.jetshop.se') !== -1 ||
        window.location.host.search('localhost') !== -1);

    return channelsRaw.filter(
      (channel) =>
        (isDev || !channel.url.includes('jetshop')) &&
        (getB2B ? channel.name.includes('B2B') : !channel.name.includes('B2B'))
    );
  };

  const prepareChannel = (channel) => {
    return {
      ...channel,
      country: channel.countries[0],
      currency: channel.currencies.filter((lang) => lang.isDefault)[0],
      language: channel.languages.filter((lang) => lang.isDefault)[0],
    };
  };

  //GO TO THE OPPOSITE CHANNEL TYPE, PREFERABLY IN THE SAME COUNTRY
  const goToChannel = () => {
    const channelCountryName = selectedChannel.name.replace('-B2B', '');
    const channelsFiltered = getChannels({
      channelsRaw: channels,
      getB2B: !isB2B,
    });
    const gotToChannel =
      channelsFiltered.find((x) => x.name === channelCountryName) ||
      channelsFiltered[0];

    const prepChannel = prepareChannel(gotToChannel);
    updateChannel(prepChannel);
  };

  return { isB2B, getChannels, prepareChannel, goToChannel };
};
